import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import {
  computed, defineComponent, ref, watch,
} from 'vue';
import SettingDrawer from './components/SettingDrawer/index.vue';

import Sidebar from './components/Sidebar/index.vue';
import Navbar from './components/Navbar/index.vue';
import MultipleNav from './components/MultipleNav/index.vue';
import Breadcrumb from './components/Breadcrumb/index.vue';
import TheRouterView from './components/RouterView/index';

export default defineComponent({
  name: 'layout',
  components: {
    Sidebar,
    Navbar,
    MultipleNav,
    SettingDrawer,
    Breadcrumb,
    TheRouterView,
  },
  setup() {
    const { getters } = useStore();
    const route = useRoute();
    const drawerDisplay = ref(null);
    const isCollapse:any = ref(false);

    const layout = computed(() => getters.layout);

    const useSidebar = computed(() => getters.useSidebar);
    const useMultipleNav = computed(() => getters.useMultipleNav);
    const useBreadcrumb = computed(() => getters.useBreadcrumb);

    const showAside = () => !route.meta.hideAside && useSidebar;
    const showHeader = () => !route.meta.hideHeader;


    /**
     * @description: 获取左侧导航类名，第一次进入系统不加动效
     */
    const getAsideClassName = () => {
      if (isCollapse.value === true) {
        return `collapse aside__maia-${getters.sidebarBackground}`;
      }
      if (isCollapse.value === false) {
        return `no-collapse aside__maia-${getters.sidebarBackground}`;
      }
      return `aside__maia-${getters.sidebarBackground}`;
    };

    /**
     * @description: 获取顶部导航类名
     */
    const getHeaderClassName = () => `header__maia-${getters.navbarBackground}`;

    watch(
      () => getters.collapse,
      (newValue) => {
        isCollapse.value = newValue;
      }
    );

    return () => (
      <el-container>
        {
          layout.value === 'side' && showAside()
            ? <el-aside class={getAsideClassName()} >
              <sidebar is-collapse={isCollapse.value} />
            </el-aside>
            : null
        }
        {
          layout.value === 'mix' && showHeader()
            ? <el-header class={getHeaderClassName()}>
              <navbar is-collapse={isCollapse.value} />
            </el-header>
            : null
        }

        <el-container class={layout.value === 'mix' ? 'el-container__mix' : ''}>
          {
            layout.value !== 'mix' && showHeader()
              ? <el-header class={getHeaderClassName()}>
                <navbar is-collapse={isCollapse.value} />
              </el-header>
              : null
          }
          {
            layout.value === 'mix' && showAside()
              ? <el-aside class={getAsideClassName()}>
                <sidebar is-collapse={isCollapse.value} />
              </el-aside>
              : null
          }
          {
            layout.value !== 'mix' && useMultipleNav.value
              ? <section class="nav-tag-list">
                <multiple-nav />
              </section>
              : null
          }
          <el-main
            class={
              // eslint-disable-next-line no-nested-ternary
              layout.value === 'mix'
                ? 'el-main__mix'
                : useMultipleNav.value
                  ? 'mul-nav-main'
                  : ''
            }>
            {
              layout.value === 'mix' && useMultipleNav.value
                ? <section class="nav-tag-list">
                  <multiple-nav />
                </section>
                : null
            }
            {
              layout.value !== 'side' && useBreadcrumb.value && !useMultipleNav.value
                ? <breadcrumb style="margin-top: 10px; padding-left: 12px;" />
                : null
            }

            {
              layout.value === 'mix'
                ? <el-main class={useMultipleNav.value ? 'mul-nav-main' : ''}>
                  <the-router-view />
                </el-main>
                : <the-router-view />
            }
          </el-main>
        </el-container>

        {/* <section class={drawerDisplay.value ? 'maia-layout-setting-wrap close' : 'maia-layout-setting-wrap'}>
          {
            drawerDisplay.value
              ? <span
                class="btn"
                onClick={() => {
                  drawerDisplayChange(2);
                }}>
                <svg-icon
                  icon-class="icon-close"
                />
              </span>
              : <span
                class="btn"
                onClick={() => {
                  drawerDisplayChange(1);
                }}>
                <svg-icon
                  icon-class="icon-setting"
                />
              </span>
          }
        </section> */}
        <setting-drawer visible={drawerDisplay.value} />
      </el-container>
    );
  },
});
